<template>
  <div :style="style" class="control-container">
    <div class="control-row title">
        <CktextComponent :rawHtml="control.data.data.title">    
        </CktextComponent>
        <div v-if="control.data.data.misc.required" class="required">*</div>
    </div>
    <div class="control-row">
        <CktextComponent :rawHtml="control.data.data.subtitle">    
        </CktextComponent>
    </div>
    <div class="control-row">
        <div class="field-checkbox" v-for="item in control.data.data.options" :key="item.value">
            <Checkbox inputId="item.value" name="checkbox" :value="item.value" v-model="selection" :class="{'p-invalid':submitted&&!valid}"/>
            <div class="label" :class="{'p-error':submitted&&!valid}">
                <CktextComponent :rawHtml="item.label">    
                </CktextComponent>
            </div>
        </div>
    </div>
    <div class="control-row p-error" v-if="submitted&&!requiredvalid">
        {{$t('message.must_check_one_item')}}
    </div>    
  </div>
</template>

<script>
import Checkbox from 'primevue/checkbox';
import CktextComponent from '../CkText.vue';

export default {
  name: 'CheckBox',
  components: {
    Checkbox,
    CktextComponent
  },
  data(){
    return {
      requiredvalid:true,
      valid:true,
      style:'',
      submitted:false,
      selection:[]
    }
  },
  props: {
    control: null
  },
  methods:{
    validateData(){

      this.submitted=true;

      this.requiredvalid=(this.selection.length>0&&this.control.data.data.misc.required)||!this.control.data.data.misc.required

      this.valid=this.requiredvalid;

      return {
        valid:this.valid,
        data:this.selection,
        type:2
      };

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);

    this.selection=this.control.data.data.selection;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control-container:last-child{
      margin-bottom: 0px;
  }
  .control-row{
      margin-bottom: 10px;
      text-align:left;
  }

  .input-container{
    border:1px solid lightgray;
    border-radius: 5px;
    padding: 10px;
    margin-top: 10px;
  }

  .title{
      display: flex;
  }
  .required{
    color:#f7363f;
  }  
  .field-checkbox{
    display: flex;
    margin-bottom: 10px;
    align-items: center;
  }
  .label{
    margin-left:0.5rem;
  }  
</style>